import * as React from "react";
import { mergeStyleSets, Spinner, SpinnerSize, useTheme } from "@fluentui/react";

const getClassNames = (theme) =>
  mergeStyleSets({
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginTop: theme.spacing.l1,
      paddingTop: theme.spacing.l1,
    },
    header: {
      color: theme.palette.themePrimary,
      fontSize: 32,
      fontWeight: 400,
    },
  });

const Progress = ({ logo, message, title }) => {
  const theme = useTheme();
  let { root, header } = getClassNames(theme);
  return (
    <section className={root}>
      <img width="100" height="100" src={logo} alt={title} title={title} />
      <h1 className={header}>{title}</h1>
      <Spinner size={SpinnerSize.large} label={message} />
    </section>
  );
};

export default Progress;
